import { invoke } from '@yoda/bridge';


const webviewNamespace = 'webview';
const uiNamespace = 'ui';
export async function useBridge(nameSpaceApi, params, cb) {
    try {
        const response = await invoke(nameSpaceApi, params, cb);
        response.result = response.result || 1;
        return response;
    } catch (error) {
        return { result: -1 };
    }
}

export async function canBridgeUse(namespace, api) {
    // 线上有些存量app ua中没有注入yoda，但yoda相关依然可用
    // if (!inYoda) {
    //     return false;
    // }
    // bridge升级无需业务方关心是否 ready
    // if (!yoda.tool || !yoda.tool.canIUse) {
    //     // 遇到过该方法有概率不存在，会导致页面功能异常
    //     // canIUse理论上是yoda从开始就有的方法
    //     // 复现现场发现客户端存在该方法，如果yoda-sdk重新注册一下是可以使用的
    //     await yoda.ready();
    //     yoda.register({
    //         namespace: 'tool',
    //         name: 'canIUse',
    //     });
    // }
    try {
        const params = {
            namespace,
            name: api,
        };
        const nameSpaceApi = 'tool.canIUse';
        const response = await useBridge(nameSpaceApi, params);
        const { canUse } = response || {};
        return canUse;
    } catch (error) {
        return false;
    }
}

export async function exitWebView(config = {}) {
    if (await canBridgeUse(webviewNamespace, 'close')) {
        const nameSpaceApi = 'webview.close';
        return await useBridge(nameSpaceApi, config);
    }
    if (await canBridgeUse(webviewNamespace, 'exitWebView')) {
        // 默认快手端内有这个方法
        const nameSpaceApi = 'webview.exitWebView';
        return await useBridge(nameSpaceApi, config);
    }
    window.close();
    window.open('about:blank', '_top').close();
}

// 因为外部调用都只传递了title
export async function setPageTitle(title) {
    if (await canBridgeUse(uiNamespace, 'setTitle')) {
        const nameSpaceApi = 'ui.setTitle';
        return await useBridge(nameSpaceApi, { title });
    }
    if (await canBridgeUse(uiNamespace, 'setPageTitle')) {
        const nameSpaceApi = 'ui.setPageTitle';
        return await useBridge(nameSpaceApi, { title });
    }
    // throw new Error('Bridge Unsupported: setPageTitle');
}

